import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import { getToken } from '@/utils/auth'
import store from '../store'
import {fitterSendDlg} from "./netFitter";

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  withCredentials: false,
  timeout: 1000 * 60 * 3 // 请求超时时间
  // timeout: 15000 // 请求超时时间
})


// request拦截器
service.interceptors.request.use(config => {

  if (store.getters.token)
  {
    config.headers['Authorization'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  }

  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(response => {
  /**
  * code为非200是抛错 可结合自己业务进行修改
  */
    const res = response.data
    if(res.code == undefined)
    {
      return response
    }
    // console.log("service.interceptors.response",res)
    if (res.code !== 20000) {
      Message({
        message: res.message,
        type: 'error',
        duration: 3 * 1000
      })

      // 401:未登录;
      if (res.code === 401) {
        MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          store.dispatch('FedLogOut').then(() => {
            location.reload()// 为了重新实例化vue-router对象 避免bug
            this.$router.push({path: '/login'})
          })
        })
      }
      if (res.code === 100004) {

        store.dispatch('FedLogOut').then(() => {
          location.reload()// 为了重新实例化vue-router对象 避免bug
          this.$router.push({path: '/login'})
        })
      }
      // return Promise.reject('error')
      return response.data
    } else {
      return response.data
    }




  },
  error => {
    //console.log('err' + error)// for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 3 * 1000
    })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js